module.exports = __webpack_public_path__ + "img/small-3.60acd6fc.jpg";